import type { User, UserMinified } from './user'

export interface PromptAdPlaceholder {
  isAd: true
}

export interface AdStatus {
  'in-content': boolean
  'lead-banner': boolean
  'rectangle-banner': boolean
}

export interface PromptAd {
  id: number
  description: string
  title: string
  url: string
  createdAt: string
  user?: User | UserMinified
  cta: string
  banner?: string
}

export interface BannerAd {
  id: number
  banner: string
  bannerTablet: string
  bannerMobile: string
  url: string
}

export type AdDevice = 'mobile' | 'tablet' | 'desktop'
export type AdType = 'lead-banner' | 'rectangle-banner' | 'in-content'

export const asBannerAd = (target: any) => {
  const entity = target as BannerAd
  if (entity && 'banner' in entity)
    return entity
}

export const asPromptAd = (target: any) => {
  const entity = target as PromptAd
  if (entity && 'title' in entity)
    return entity
}

export function isAd(obj: any): obj is PromptAdPlaceholder {
  return obj && typeof obj === 'object' && 'isAd' in obj
}
